import React from 'react'
import { useParams, Link } from 'react-router-dom'
import { Check, Video, ArrowRight } from 'lucide-react';
import { Card, CardContent, CardFooter, CardHeader } from 'components/ui/card';
import { Button } from 'components/ui/button';
import Layout from 'components/layout/Layout';

const Payments = () => {
  const params = useParams();
  const status = params.status
  return (
    <Layout headerStyle={2} footerStyle={2}>
      <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-br from-blue-50 to-purple-50 p-4">

        {/* Success Card */}
        <Card className="w-full max-w-md shadow-lg border-0 bg-white/80 backdrop-blur-sm">
          <CardHeader className="flex flex-col items-center pt-8 pb-6">
            <div className="w-16 h-16 bg-gradient-to-r from-green-400 to-emerald-500 rounded-full flex items-center justify-center mb-4">
              <Check className="w-8 h-8 text-white" />
            </div>
            {status == "success" ?
              <div>
                <h1 className="text-2xl font-bold text-center text-gray-800">Payment Successful!</h1>
                <p className="text-gray-500 text-center mt-2">Your payment has been processed successfully.</p>
              </div> :
              <div>
                <h1 className="text-2xl font-bold text-center text-gray-800">Payment Failed!</h1>
                <p className="text-gray-500 text-center mt-2">Your payment has been failed.</p>
              </div>
            }
          </CardHeader>

          <CardContent className="px-8">
            <div className="space-y-3 mb-6">
              <div className="flex justify-between py-2 border-b border-gray-100">
                <span className="text-gray-600">Transaction ID</span>
                <span className="font-medium">EDIT-{Math.floor(Math.random() * 1000000).toString().padStart(6, '0')}</span>
              </div>
              <div className="flex justify-between py-2 border-b border-gray-100">
                <span className="text-gray-600">Plan</span>
                <span className="font-medium">Pro Editor</span>
              </div>
              <div className="flex justify-between py-2 border-b border-gray-100">
                <span className="text-gray-600">Credits</span>
                <span className="font-medium text-blue-600">100 Credits Added</span>
              </div>
            </div>

            <div className="bg-gradient-to-r from-pink-100 to-purple-100 p-4 rounded-lg mb-2">
              <h3 className="font-medium text-purple-800 mb-1">What's Next?</h3>
              <p className="text-sm text-gray-700">Start creating amazing videos with AI-powered tools, transitions, captions, and sound effects!</p>
            </div>
          </CardContent>

          <CardFooter className="flex items-center justify-center gap-3 px-8 pb-8">
            <Link to="/generatevideo">Create A Video</Link>
            <Button to="/profilepage" className="text-white rounded">Go To Profile</Button>
          </CardFooter>
        </Card>

        {/* Decorative Elements */}
        <div className="absolute top-20 left-20 w-16 h-16 bg-gradient-to-r from-blue-400 to-purple-400 rounded-xl opacity-20 blur-xl"></div>
        <div className="absolute bottom-20 right-20 w-24 h-24 bg-gradient-to-r from-pink-400 to-orange-400 rounded-full opacity-20 blur-xl"></div>
        <div className="absolute top-1/3 right-1/4 w-12 h-12 bg-gradient-to-r from-blue-300 to-cyan-300 rounded-lg opacity-20 blur-lg"></div>
      </div>
    </Layout>
  );
};

export default Payments;